<template>
  <router-view v-slot="{ Component }">
    <transition name="fade" appear mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script setup lang="ts">
import { useAccountStore } from "@/stores/account";
import { useUIStore } from "@/stores/ui";

const { getAccount, getCsrfToken, getCountryConfig } = useAccountStore();

getAccount();
getCsrfToken();
getCountryConfig();
useUIStore();
</script>
